<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <el-button icon="el-icon-refresh" :loading="loading" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>弹框分布</span>
        </div>

        <el-card>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="date"
              align="center"
              label="日期"
              width="120"
            />
            <el-table-column
              v-for="(item, index) in typeData"
              :key="index"
              prop="date"
              align="center"
              :label="item.label"
            >
              <el-table-column
                align="center"
                label="弹框数"
                width="120"
              >
                <template v-slot:default="scope">
                  <span v-if="scope.row.data.data[item.label]">{{ scope.row.data.data[item.label].page_count }}</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="点击数"
                width="120"
              >

                <template slot="header">
                  <el-popover
                    placement="top-start"
                    width="260"
                    trigger="hover"
                    content="点击数=弹框后点击支付"
                  >
                    <span slot="reference">点击数 <i class="el-icon-warning-outline" /></span>
                  </el-popover>
                </template>

                <template v-slot:default="scope">
                  <span v-if="scope.row.data.data[item.label]">{{ scope.row.data.data[item.label].click_count }}</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="打开率"
                width="120"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    width="260"
                    trigger="hover"
                    content="打开率=打开人数/DAU "
                  >
                    <span slot="reference">打开率 <i class="el-icon-warning-outline" /></span>
                  </el-popover>
                </template>
                <template v-slot:default="scope">
                  <span v-if="scope.row.data.data[item.label]">{{ scope.row.data.data[item.label].open_rate }}%</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="下单成功"
                width="120"
              >
                <template v-slot:default="scope">
                  <span v-if="scope.row.data.data[item.label]">{{ scope.row.data.data[item.label].pay_count }}</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="下单率"
                width="120"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    width="260"
                    trigger="hover"
                    content="下单率=支付次数/点击次数 "
                  >
                    <span slot="reference">下单率 <i class="el-icon-warning-outline" /></span>
                  </el-popover>
                </template>
                <template v-slot:default="scope">
                  <span v-if="scope.row.data.data[item.label]">{{ scope.row.data.data[item.label].pay_rate }}%</span>
                  <span v-else>0</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-card>
      </el-card>

      <!--      <el-row v-for="(item, index) in typeData" :key="index" style="margin-top: 15px" :gutter="12">-->
      <!--        <popStat :ref="'stat'+item.value" :typ="item.value" />-->
      <!--      </el-row>-->

      <el-row style="margin-top: 15px" :gutter="12">
        <popPayStat ref="pay_stat" />
      </el-row>

      <el-card class="box-card">
        <el-row style="margin-top: 15px" :gutter="12">
          <popStat2 ref="popUpPage" typ="page_count" />
        </el-row>
      </el-card>

      <el-card class="box-card">
        <el-row style="margin-top: 15px" :gutter="12">
          <popStat2 ref="popUpPay" typ="pay_count" title="下单次数" />
        </el-row>
      </el-card>

      <el-card class="box-card">
        <el-row style="margin-top: 15px" :gutter="12">
          <popStat2 ref="popUpOrder" typ="pay_rate" title="下单率" />
        </el-row>
      </el-card>

    </template>
  </BasicLayout>
</template>
<script>
import popStat2 from '@/views/config/pay-stat/components/pop-stat2.vue'
import popPayStat from '@/views/config/pay-stat/components/pop_pay_stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
import { getPayPopUpRateStat } from '@/api/statistics/user_remain'
export default {
  name: 'PopUpStat',
  components: {
    popStat2,
    popPayStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      tab: [{ value: 1, label: '昨天' }, {}],
      activeName: '',
      typeData: [
        { value: 601, label: '首充' }, // 首冲
        { value: 801, label: 'VIP' }, // 首冲
        { value: 2000, label: '商城' }, // 商城
        { value: 1501, label: '金币不足' }, // 金币不足
        { value: 1502, label: '体力不足' }, // 体力不足
        { value: 1511, label: '钻石不足' }, // 钻石不足
        { value: 1809, label: '通行证' }, // 通行证
        { value: 2101, label: '规则礼包' }, // 规则礼包
        { value: 11200, label: '等级礼包' }, // 等级礼包
        { value: 90002, label: '三选一' }, // 三选一
        { value: 90030, label: '一加二礼包' }, // 一加二礼包
        { value: 100000, label: '三格礼包' }, // 三格礼包
        { value: 120000, label: '六格礼包' }, // 六格礼包
        { value: 150000, label: '六格礼包2' }, // 六格礼包
        { value: 800001, label: '小猪体力罐' }, // 小猪体力罐
        { value: 1050, label: '主题礼包' } // 主题礼包
      ],
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    exportData() {
      this.loading = true
      this.queryParams.type = 1
      getPayPopUpRateStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.loading = true
      this.queryParams.type = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getPayPopUpRateStat(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        // const popYypeData = res.data.types
        const data = res.data.data
        this.tableData = data
        this.$refs.pay_stat.refresh(data)
        this.$refs.popUpPage.refresh(data, this.typeData)
        this.$refs.popUpPay.refresh(data, this.typeData)
        this.$refs.popUpOrder.refresh(data, this.typeData)
        // for (const i in this.typeData) {
        //   const val = this.typeData[i]
        //   const key = `stat${val.value}`
        //   if (this.$refs[key]) {
        //     this.$refs[key][0].refresh(data, this.typeData)
        //   }
        // }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped>
</style>
